
import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

const HreflangTags: React.FC = () => {
  const location = useLocation();
  const baseUrl = 'https://psychotherapist.help';

  const generateHreflangUrls = () => {
    // All 40 supported languages
    const languages = [
      'en', 'es', 'fr', 'de', 'it', 'pt',
      'da', 'no', 'fi', 'sv', 'is',
      'cs', 'sk', 'sl', 'pl',
      'et', 'lv', 'lt',
      'el', 'nl',
      'ko', 'ja', 'zh',
      'ar', 'hi', 'ru', 'tr', 'id',
      'ro', 'bg', 'hr', 'hu', 'uk', 'he',
      'th', 'vi', 'ms', 'tl', 'fa', 'bn', 'ur', 'sw'
    ];
    
    const hreflangUrls = [];

    languages.forEach(lang => {
      const url = lang === 'en' 
        ? `${baseUrl}${location.pathname}`
        : `${baseUrl}/${lang}${location.pathname}`;
      hreflangUrls.push({ lang, url });
    });

    // Add x-default
    hreflangUrls.push({ 
      lang: 'x-default', 
      url: `${baseUrl}${location.pathname}`
    });

    return hreflangUrls;
  };

  const hreflangUrls = generateHreflangUrls();

  return (
    <Helmet>
      {hreflangUrls.map(({ lang, url }) => (
        <link key={lang} rel="alternate" hrefLang={lang} href={url} />
      ))}
    </Helmet>
  );
};

export default HreflangTags;
